import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Login, Main } from "./pages";

import "./App.css";

const App = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="*" element={<Main />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
